export default __webpack_public_path__ + "static/media/ceyda.4aaafbfe.jpg";